import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static targets = ["fieldset"];
  declare fieldsetTargets: HTMLFieldSetElement[];

  onChange = (evt: Event) => {
    const input = evt.target as HTMLInputElement | null;

    if (input) {
      this.fieldsetTargets.forEach((target) => {
        target.disabled = target.dataset.value !== input.value;
      });
    }
  };
}
